export const isFreeTier = (template, tier) =>
  template?.prices?.length ? template.prices.every((p) => p.amount === 0) : tier === 'basic';
